
  import { Vue, Component, Prop } from "vue-property-decorator";

  import TableAvatar from "@/components/table/TableAvatar.vue";

  import getInitials from "@/helpers/getInitials";

  import EmployeeDropdownOption from "@/entities/EmployeeDropdownOption";

  @Component({
    components: {
      TableAvatar,
    }
  })
  export default class MultiselectAvatar extends Vue {
    @Prop({ type: Object, required: true }) readonly option!: EmployeeDropdownOption;

    get avatar(): string {
      return this.option?.avatar || "";
    }

    get initials(): string {
      const { given_name:givenName = "", family_name:familyName = "" } = this.option;
      return getInitials(givenName, familyName);
    }
  }
